import { useCallback, useEffect, useState, type ReactNode } from 'react';
import { SIDEBAR_STORAGE_KEY, SidebarContext } from './SidebarContext';

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsedState] = useState(() => {
    try {
      const raw = localStorage.getItem(SIDEBAR_STORAGE_KEY);
      return raw === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_STORAGE_KEY, String(collapsed));
    } catch {
      // ignorar
    }
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsedState((v) => !v), []);
  const setCollapsed = useCallback((v: boolean) => setCollapsedState(v), []);

  return (
    <SidebarContext.Provider value={{ collapsed, toggle, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
}
